import { TabNames } from './../../const/check';
import { ReviewResult } from 'types/check';
import { DocumentCategory, Review } from 'types/review-category';
import { AssessmentPagePayload } from 'types/assessment-payload';

import {
  CHECK_CATEGORY_CHANGE,
  CHECK_SELECTION,
  FETCH_ASSESSMENT_PAGE_ERROR,
  FETCH_ASSESSMENT_PAGE_START,
  FETCH_ASSESSMENT_PAGE_SUCCESS,
  GET_ASSESSMENT_PAGE,
  PAGE_CHANGE,
  SCALE_CHANGE,
  SET_EXTERNAL_ID,
  SET_PREV_EXTERNAL_ID,
  SET_QUALITY_CHECK_TABNAME,
  TOGGLE_BORDERS_VISIBILITY,
} from './types';

export const ERROR_MESSAGE =
  'Error happened while loading, try reloading the page';

interface IFetchAssessmentPageAction {
  type: typeof GET_ASSESSMENT_PAGE;
  pageNumber: number;
  token: string;
}

export interface IFetchAssessmentPageStart {
  type: typeof FETCH_ASSESSMENT_PAGE_START;
}

export interface IFetchAssessmentPageSuccess {
  type: typeof FETCH_ASSESSMENT_PAGE_SUCCESS;
  currentPage: AssessmentPagePayload;
}

export interface IFetchAssessmentPageError {
  type: typeof FETCH_ASSESSMENT_PAGE_ERROR;
  error: {
    message: string;
    statusCode: number;
  };
}

export interface IPageChange {
  type: typeof PAGE_CHANGE;
  pageNumber: number;
}

export interface IScaleChange {
  type: typeof SCALE_CHANGE;
  scale: number;
}

export interface ICheckCategoryChange {
  type: typeof CHECK_CATEGORY_CHANGE;
  category: Review | DocumentCategory;
  result: ReviewResult | null;
}

export interface ICheckSelection {
  type: typeof CHECK_SELECTION;
  id: string | null;
}

export interface IExternalId {
  type: typeof SET_EXTERNAL_ID | typeof SET_PREV_EXTERNAL_ID;
  id: string | null;
}

export interface IToggleBordersVisibility {
  type: typeof TOGGLE_BORDERS_VISIBILITY;
}

export interface IChangeTabName {
  type: typeof SET_QUALITY_CHECK_TABNAME;
  tabTitle: TabNames;
}

export function pageChangeAction(pageNumber: number): IPageChange {
  return {
    type: PAGE_CHANGE,
    pageNumber,
  };
}

export function zoomAction(scale: number): IScaleChange {
  return {
    type: SCALE_CHANGE,
    scale,
  };
}

export function checkCategoryChangeAction(
  category: Review | DocumentCategory,
  result: ReviewResult | null
): ICheckCategoryChange {
  return {
    type: CHECK_CATEGORY_CHANGE,
    category,
    result,
  };
}

export function setTabNameTitle(tabTitle: TabNames): IChangeTabName {
  return {
    type: SET_QUALITY_CHECK_TABNAME,
    tabTitle,
  };
}

export function checkSelectionAction(id: string | null): ICheckSelection {
  return {
    type: CHECK_SELECTION,
    id,
  };
}

export function setExternalIdAction(id: string | null): IExternalId {
  return {
    type: SET_EXTERNAL_ID,
    id,
  };
}

export function setPrevExternalIdAction(id: string | null): IExternalId {
  return {
    type: SET_PREV_EXTERNAL_ID,
    id,
  };
}

export function toggleBordersVisibility() {
  return {
    type: TOGGLE_BORDERS_VISIBILITY,
  };
}

export function fetchAssessmentPageAction(
  pageNumber: number,
  token: string
): IFetchAssessmentPageAction {
  return {
    type: GET_ASSESSMENT_PAGE,
    pageNumber,
    token,
  };
}

export function fetchAssessmentPageStartAction(): IFetchAssessmentPageStart {
  return {
    type: FETCH_ASSESSMENT_PAGE_START,
  };
}

export function fetchAssessmentPageSuccessAction(
  currentPage: AssessmentPagePayload
): IFetchAssessmentPageSuccess {
  return {
    type: FETCH_ASSESSMENT_PAGE_SUCCESS,
    currentPage,
  };
}

export function fetchAssessmentPageErrorAction(
  statusCode: number,
  message = ERROR_MESSAGE
): IFetchAssessmentPageError {
  return {
    type: FETCH_ASSESSMENT_PAGE_ERROR,
    error: {
      message,
      statusCode,
    },
  };
}
